<div class="page-bg">


<div class="dashboard-container">



<!-- HEADER -->

<div class="hero-card">


<div>


<p class="small-title">
GOOD DAY 👋
</p>


<h1>
Welcome back,
{{merchant?.business_name}}
</h1>


<p class="description">
Manage your wedding business, services and bookings.
</p>


<div class="actions">


<a routerLink="/merchant/services"
class="primary-btn">

<span class="material-symbols-outlined">
add
</span>

Add Service

</a>



<a routerLink="/merchant/calendar"
class="secondary-btn">

<span class="material-symbols-outlined">
calendar_month
</span>

Calendar

</a>


</div>


</div>





<div class="avatar">

{{merchant?.business_name?.charAt(0)}}

</div>


</div>






<!-- STATS -->


<div class="stats-grid">


<div class="stat-card">

<div class="icon">
  <span class="material-symbols-outlined">
    storefront
  </span>
</div>

<div>

<label>
Services
</label>

<h2>
{{dashboard.services}}
</h2>

</div>

</div>






<div class="stat-card">

<div class="icon">
  <span class="material-symbols-outlined">
    event
  </span>
</div>

<div>

<label>
Bookings
</label>

<h2>
{{dashboard.bookings}}
</h2>

</div>

</div>






<div class="stat-card">

<div class="icon">
  <span class="material-symbols-outlined">
    payments
  </span>
</div>

<div>

<label>
Revenue
</label>

<h2>
₹{{formatMoney(dashboard.revenue)}}
</h2>

</div>

</div>






<div class="stat-card">

<div class="icon">
  <span class="material-symbols-outlined">
    star
  </span>
</div>

<div>

<label>
Rating
</label>

<h2>
{{dashboard.rating}}
</h2>

</div>

</div>



</div>









<!-- BOOKING SUMMARY -->


<div class="panel">


<h2>
Booking Summary
</h2>


<div class="summary-grid">


<div>
<strong>
{{dashboard.acceptedBookings}}
</strong>
<span>
Accepted
</span>
</div>



<div>
<strong>
{{dashboard.pendingBookings}}
</strong>
<span>
Pending
</span>
</div>



<div>
<strong>
{{dashboard.rejectedBookings}}
</strong>
<span>
Rejected
</span>
</div>



<div>
<strong>
{{dashboard.blockedDates}}
</strong>
<span>
Blocked Dates
</span>
</div>


</div>


</div>









<!-- UPCOMING BOOKINGS -->


<div class="panel">


<h2>
Upcoming Bookings
</h2>



<div
class="booking-item"
*ngFor="
let booking of dashboard.upcomingBookings
">


<div>

<h3>
{{booking.customer_name}}
</h3>


<p>
{{booking.function_name}}
-
{{booking.location}}
</p>

</div>



<div>

<strong>
₹{{booking.price | number}}
</strong>


<p>

{{booking.selectedDate.day}}/
{{booking.selectedDate.month}}/
{{booking.selectedDate.year}}

</p>


</div>


</div>




<div
class="empty"
*ngIf="
dashboard.upcomingBookings.length===0
">

No bookings available

</div>


</div>









<!-- QUICK ACTIONS -->


<div class="panel">


<h2>
Quick Actions
</h2>



<div class="quick-actions">


<button routerLink="/merchant/services">
Add Service
</button>


<button routerLink="/merchant/bookings">
Bookings
</button>


<!-- <button routerLink="/merchant/payments">
Payments
</button> -->


<button routerLink="/merchant/profile">
Profile
</button>


</div>


</div>




</div>


</div>